<template>
  <div>
    <div class="flex justify-between">
      <div class="flex justify-between">
        <venue-selector
          v-model="filterVenue"
          @venue="onVenueSelected"
          style="width: 350px"
          :filterCountries="[activeCountry.name]"
          :globalMode="true"
          :multiple="false"
        />
      </div>
      <div class="flex justify-end">
        <vs-button
          @click="confirmAddLocation(1)"
          :disabled="isLoading"
          icon="add"
          class="mr-3"
          type="relief"
          color="primary"
          >Add storage</vs-button
        >
        <vs-button
          @click="confirmAddLocation(2)"
          :disabled="isLoading"
          icon="add"
          type="relief"
          color="primary"
          >Add bar</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        v-if="!isLoading"
        ref="table"
        class="mt-4"
        pagination
        max-items="99"
        :data="pimStockLocations.locations"
      >
        <template slot="thead" v-if="!isLoading">
          <vs-th sort-key="number"></vs-th>
          <vs-th sort-key="displayName">Name</vs-th>
          <vs-th sort-key="displayName">Main storage</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <!-- <p class="ml-4">Bar</p> -->
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.name">
                  {{ tr.name }}
                </div>
                <div v-else>
                  <vs-chip> No name </vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip>
                  {{ tr.isMainStorage | yesno }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <feather-icon
                  v-if="!tr.isMainStorage"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="confirmRemovePimStockLocation(tr.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div
        v-if="isLoading"
        class="
          mt-10
          my-auto
          vx-col
          flex
          items-center
          align-center
          justify-center
          flex-col
          sm:w-1/2
          md:w-3/5
          lg:w-2/4
          xl:w-2/4
          mx-auto
          text-center
        "
      >
        <img
          src="@/assets/images/no_venue_selected.png"
          alt="graphic-404"
          class="mx-auto mb-4"
          style="width: 150px"
        />
        <h5 class="sm:mx-0 mx-4 mt-4 text-xl d-theme-text">
          Select a venue to continue
        </h5>
        <!-- <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text">
            Select a venue to continue
          </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/storage_icon.png";
import VenueSelector from "@/components/VenueSelector.vue";
export default {
  components: { VenueSelector },
  data() {
    return {
      filterVenue: null,
      currentVenue: null,
      isLoading: true,
      ProductIcon,
    };
  },
  methods: {
    async onVenueSelected(venue) {
      console.log("Selected venue", venue);
      if (!venue) {
        this.currentVenue = null;
        this.isLoading = true;
        return;
      }
      this.currentVenue = venue;
      this.isLoading = true;
      await this.$store.dispatch(
        "venues/getPimStockLocations",
        this.currentVenue.venueId
      );
      this.isLoading = false;
    },
    confirmAddLocation(type) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Add location",
        text: "Are you sure you want to add a new stock location?",
        accept: () => {
          this.addLocation(type);
        },
      });
    },
    addLocation(type) {
      console.log("addLocation", type);
      this.$store
        .dispatch("venues/addPimStockLocation", {
          type: type,
          venueId: this.currentVenue.venueId,
        })
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Location added",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: error.message,
            color: "danger",
          });
        });
    },
    confirmRemovePimStockLocation(location) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Remove location",
        text: "Are you sure you want to remove this location?",
        accept: () => {
          this.removePimStockLocation(location);
        },
      });
    },
    removePimStockLocation(location) {
      this.$store
        .dispatch("venues/deletePimStockLocation", {
          id: location,
          venueId: this.currentVenue.venueId,
        })
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Location removed",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: error.message,
            color: "danger",
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      pimStockLocations: "venues/pimStockLocations",
      activeCountry: "venues/activeCountry",
    }),
  },

  async created() {},
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
